import React from 'react';

const RadioButton = ({ ...rest }) => {
  return <nsemble-radio-button {...rest} />;
};

export default RadioButton;
